import { Dialog, DialogChainObject } from 'quasar';
import { IValidationBaseDTO } from 'src/services/generated/api.generated.v1';
import {i18n} from 'src/boot/i18n';

export default class DialogHelper {
    static ShowError(result?: IValidationBaseDTO | null | undefined): DialogChainObject {
        const messageHtml = [ 
            `<p>${i18n.t('errorInstruction').toString()}</p>`,
            '<ul>' 
        ];

        if (result && result.errors && result.errors.length > 0) {
            result.errors.forEach(err => {
                messageHtml.push(`<li>${err}</li>`);
            });
        } else {
            messageHtml.push(`<li>${i18n.t('unexpectedError').toString()}</li>`)
        }

        messageHtml.push('</ul>');
        
        return Dialog.create({
            title: i18n.t('error').toString(),
            message: messageHtml.join(''),
            html: true
        });
    }

    static ShowCustomError(errorMessage: string, isHtml: boolean): DialogChainObject {          
        return Dialog.create({
            title: i18n.t('error').toString(),
            message: errorMessage,
            html: isHtml
        });
    }
}